module.exports = __webpack_public_path__ + "static/media/registp01_en.59c4d16c.png";